import { render, staticRenderFns } from "./RecargoList.vue?vue&type=template&id=6d3c6e9a&scoped=true&"
import script from "./RecargoList.vue?vue&type=script&lang=js&"
export * from "./RecargoList.vue?vue&type=script&lang=js&"
import style0 from "./RecargoList.vue?vue&type=style&index=0&id=6d3c6e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c6e9a",
  null
  
)

export default component.exports